import { Component, OnInit,Input,EventEmitter,Output,ViewChild} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { Subject } from 'rxjs';
import { Router,ActivatedRoute } from '@angular/router';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import { SessionService } from 'src/app/Services/session.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
@Component({
  selector: 'app-question-monthly-report',
  templateUrl: './question-monthly-report.component.html',
  styleUrls: ['./question-monthly-report.component.css']
})
export class QuestionMonthlyReportComponent implements OnInit {
  QuestionMonthlyCount:any;
  Question:any;
  constructor(private toastr: ToastrService,public session:SessionService,public service:QuestionManagementService,public Activeroute:ActivatedRoute,public route:Router) { }

  ngOnInit(): void {
    this.GetQuestionMonthlyReport();
  }

  GetQuestionMonthlyReport(){
    this.service.GetQuestionMonthlyReport({'LoggedInUser':this.session.getUser()}).subscribe((i:any)=>{
      this.Question=i;
      if(this.Question.Message=='Success'){
      this.QuestionMonthlyCount=this.Question.Data;
      console.log(this.QuestionMonthlyCount,'QuestionMonthlyCount');
      }
      else{
        this.toastr.error(this.Question.Message);
      }

}, error => {  console.log(error) }
);
  }
  // ngAfterViewInit(): void {
  //   $(document).ready(function () {
  //     $('#QuestionCount').DataTable({
  //       destroy: true,
  //       'columns': [
  //         { data: 'Year'},
  //         { data: 'Month'}, 
  //         { data: 'Name'}, 
  //         { data: 'Created'}, 
  //         { data: 'Updated'}, 
  //         { data: 'Reviewed'},
  //         { data: 'Approved'},
  //      ],
  //      'columnDefs': [ {
  //         'targets': [2], 
  //         'orderable': false, 
  //      }]
  //     });
    
  //   });
  // }

}
